import { UserPermission } from "types/UserPermission";
import { VisibleSections } from "types/VisibleSections";
import { createCustomAction } from "typesafe-actions";

const USER_DATA_LOAD = "USER/USER_DATA_LOAD";
const USER_DATA_LOAD_SUCCESS = "USER/USER_DATA_LOAD_SUCCESS";
const USER_PERMISSIONDATA_LOAD_SUCCESS = "USER/USER_PERMISSIONDATA_LOAD_SUCCESS";
const USER_DATA_LOAD_FAIL = "USER/USER_DATA_LOAD_FAIL";
const USER_SELECT_USERPERMISSION = "USER/USER_SELECT_USERPERMISSION";
const USER_CHANGE_REPORT_DATE = "USER/USER_CHANGE_REPORT_DATE";
const USER_CHANGE_START_DATE = "USER/USER_CHANGE_START_DATE";

export type UserContentType = "userPermissions" | "visibleSections";

export type UserDataType = VisibleSections;

export const load = createCustomAction(
  USER_DATA_LOAD,
  (type) => (contentType: UserContentType) => ({
    type,
    contentType,
  })
);

export const loadSuccess = createCustomAction(
  USER_DATA_LOAD_SUCCESS,
  (type) => (contentType: UserContentType, data?: UserDataType) => ({
    type,
    contentType,
    data,
  })
);

export const loadPermissionsSuccess = createCustomAction(
  USER_PERMISSIONDATA_LOAD_SUCCESS,
  (type) => (contentType: UserContentType, data?: UserPermission[]) => ({
    type,
    contentType,
    data,
  })
);

export const loadFail = createCustomAction(
  USER_DATA_LOAD_FAIL,
  (type) => (contentType: UserContentType, error?: string) => ({
    type,
    contentType,
    error,
  })
);

export const selectUserPermission = createCustomAction(
  USER_SELECT_USERPERMISSION,
  (type) => (permission: string) => ({
    type,
    permission,
  })
);

export const changeReportDate = createCustomAction(
  USER_CHANGE_REPORT_DATE,
  (type) => (reportDate: string) => ({
    type,
    reportDate,
  })
);

export const changeStartDate = createCustomAction(
  USER_CHANGE_START_DATE,
  (type) => (startDate: string) => ({
    type,
    startDate,
  })
);
